import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  heading: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
  },
  secondaryHeading: {
    fontSize: '1.3rem',
    color: theme.palette.text.secondary,
  },
}))
